<template>
  <div
    class="chevron"
    :class="{ 'chevron--open': is_open }"
    :style="{ '--rotation': `${rotation}deg` }"
  >
    <vb-icon :name="icon" :size="size" :color="color"></vb-icon>
  </div>
</template>

<script>
export default {
  name: "chevron",
  props: {
    is_open: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: "chevron_down",
    },
    rotation: {
      type: Number,
      default: 180,
    },
    size: {
      type: Number,
      default: 16,
    },
    color: {
      type: String,
      default: "000000",
    },
  },
};
</script>

<style lang="scss">
.chevron {
  display: inline-flex;
  align-items: center;
  transition: $transition-base;

  &--open {
    transform: rotate(var(--rotation));
  }
}
</style>
